import React from 'react';
import LazyMetrics from '../../dashboard-year/LazyMetrics';
import EngagementByMonth from '../../dashboard-year/Partners/EngagementByMonth';
import SharedOffer from '../../dashboard-year/Partners/SharedOffer';
import InvitedToProject from '../../dashboard-year/Partners/InvitedToProject';
import InvitedToEvent from '../../dashboard-year/Partners/InvitedToEvent';
import InvitedToProjectAndResponded from '../../dashboard-year/Partners/InvitedToProjectAndResponded';
import InvitedToEventAndResponded from '../../dashboard-year/Partners/InvitedToEventAndResponded';
import CreatedInviteToProject from '../../dashboard-year/Partners/CreatedInviteToProject';
import CreatedInviteToEvent from '../../dashboard-year/Partners/CreatedInviteToEvent';
import ContributionYear from '../../dashboard-year/Partners/ContributionYear';
import PartnerGrowthByMonth from '../../dashboard-year/Partners/PartnerGrowthByMonth';
import CompositePartnerGrowth from '../../dashboard-year/Partners/CompositePartnerGrowth';
import PartnerStatusYear from '../../dashboard-year/Partners/PartnerStatusYear';

export default function Partners(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics
        // title="Growth"
        columns={1}
      >
        {/*<PartnerGrowthByMonth {...params} />*/}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <PartnerStatusYear {...params} />
        </div>
        <PartnerGrowthByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <CompositePartnerGrowth {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
      <LazyMetrics title="Engagement" columns={1}>
        <EngagementByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <SharedOffer {...params} titleOnly={true} />
          <InvitedToProject {...params} titleOnly={true} />
          <InvitedToEvent {...params} titleOnly={true} />
          <InvitedToProjectAndResponded {...params} titleOnly={true} />
          <InvitedToEventAndResponded {...params} titleOnly={true} />
          <CreatedInviteToProject {...params} titleOnly={true} />
          <CreatedInviteToEvent {...params} titleOnly={true} />
          <ContributionYear {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
    </>
  );
}
